import React from 'react'
import { authRoles } from 'app/auth/authRoles'

const generalSettingsRoutes = [
    {
        path: '/Settings/General',
        component: React.lazy(() => import('./GeneralSettingsPage')),
        auth: authRoles.admin,
        accessPageName: 'SETTINGS',
    },
]

export default generalSettingsRoutes

